/**
 * PremiumIconComponent Constants
 */

export const PREMIUM_ICON_WEB_COMPONENT = 'premium-icon-component';
